import {
  discordLink,
  facebookLink,
  instagramLink,
  pinterestLink,
  snapchatLink,
  tiktokLink,
  youtubeLink,
} from "@/utils/branch"
import { devices } from "@/utils/breakpoints"

import styled from "styled-components"

const SocialsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  height: 42px;

  margin-bottom: 10px;

  @media ${devices.tablet} {
    margin: 0;
  }
`

const SocialImage = styled.a`
  cursor: pointer;

  * path {
    transition: fill 200ms ease-in-out;
  }

  :hover {
    * path[fill="var(--color-blue-600)"] {
      fill: var(--color-blue-900);
    }
  }

  height: 42px;

  @media ${devices.tablet} {
    height: 33px;
  }

  @media ${devices.desktop} {
    height: 42px;
  }
`

const Socials = () => {
  return (
    <SocialsContainer>
      {[
        {
          icon: (
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.723 20.9993C18.723 19.4653 19.9662 18.2213 21.5003 18.2213C23.0344 18.2213 24.2783 19.4653 24.2783 20.9993C24.2783 22.5334 23.0344 23.7773 21.5003 23.7773C19.9662 23.7773 18.723 22.5334 18.723 20.9993ZM17.2213 20.9993C17.2213 23.3627 19.137 25.2784 21.5003 25.2784C23.8636 25.2784 25.7794 23.3627 25.7794 20.9993C25.7794 18.636 23.8636 16.7203 21.5003 16.7203C19.137 16.7203 17.2213 18.636 17.2213 20.9993ZM24.9488 16.5506C24.9487 16.7484 25.0073 16.9418 25.1171 17.1063C25.2269 17.2707 25.383 17.399 25.5657 17.4747C25.7484 17.5505 25.9495 17.5704 26.1435 17.5319C26.3375 17.4934 26.5157 17.3982 26.6556 17.2584C26.7955 17.1186 26.8908 16.9405 26.9295 16.7465C26.9681 16.5525 26.9484 16.3515 26.8728 16.1687C26.7972 15.9859 26.6691 15.8297 26.5047 15.7198C26.3403 15.6098 26.1469 15.5511 25.9492 15.551H25.9488C25.6837 15.5511 25.4294 15.6565 25.2419 15.8439C25.0544 16.0313 24.949 16.2855 24.9488 16.5506ZM18.1336 27.7825C17.3212 27.7455 16.8796 27.6101 16.5861 27.4958C16.1971 27.3443 15.9195 27.1639 15.6276 26.8725C15.3357 26.581 15.1551 26.3037 15.0043 25.9146C14.8899 25.6213 14.7545 25.1795 14.7176 24.3671C14.6772 23.4887 14.6691 23.2248 14.6691 20.9994C14.6691 18.774 14.6779 18.5109 14.7176 17.6317C14.7546 16.8193 14.8909 16.3784 15.0043 16.0842C15.1557 15.6951 15.3361 15.4175 15.6276 15.1257C15.9191 14.8338 16.1964 14.6531 16.5861 14.5023C16.8795 14.3879 17.3212 14.2526 18.1336 14.2157C19.012 14.1753 19.2759 14.1672 21.5003 14.1672C23.7247 14.1672 23.9888 14.1759 24.868 14.2157C25.6804 14.2527 26.1213 14.389 26.4155 14.5023C26.8046 14.6531 27.0822 14.8342 27.374 15.1257C27.6659 15.4171 27.8459 15.6951 27.9974 16.0842C28.1118 16.3775 28.2471 16.8193 28.284 17.6317C28.3244 18.5109 28.3325 18.774 28.3325 20.9994C28.3325 23.2248 28.3244 23.4879 28.284 24.3671C28.247 25.1795 28.111 25.6211 27.9974 25.9146C27.8459 26.3037 27.6655 26.5813 27.374 26.8725C27.0826 27.1637 26.8046 27.3443 26.4155 27.4958C26.1222 27.6102 25.6804 27.7455 24.868 27.7825C23.9896 27.8229 23.7257 27.8309 21.5003 27.8309C19.2749 27.8309 19.0118 27.8229 18.1336 27.7825ZM18.0646 12.7165C17.1775 12.7569 16.5713 12.8975 16.0419 13.1035C15.4937 13.3163 15.0295 13.6017 14.5657 14.0647C14.1019 14.5278 13.8173 14.9927 13.6045 15.5409C13.3985 16.0707 13.2579 16.6765 13.2175 17.5637C13.1764 18.4522 13.167 18.7363 13.167 20.9993C13.167 23.2624 13.1764 23.5465 13.2175 24.435C13.2579 25.3222 13.3985 25.928 13.6045 26.4577C13.8173 27.0057 14.102 27.4711 14.5657 27.9339C15.0295 28.3968 15.4937 28.6818 16.0419 28.8951C16.5723 29.1011 17.1775 29.2418 18.0646 29.2822C18.9536 29.3226 19.2372 29.3327 21.5003 29.3327C23.7634 29.3327 24.0474 29.3233 24.936 29.2822C25.8232 29.2418 26.429 29.1011 26.9587 28.8951C27.5066 28.6818 27.9711 28.397 28.4349 27.9339C28.8987 27.4709 29.1828 27.0057 29.3961 26.4577C29.6021 25.928 29.7434 25.3221 29.7832 24.435C29.8236 23.5458 29.833 23.2624 29.833 20.9993C29.833 18.7363 29.8236 18.4522 29.7832 17.5637C29.7428 16.6765 29.6021 16.0703 29.3961 15.5409C29.1828 14.993 28.898 14.5285 28.4349 14.0647C27.9718 13.6009 27.5066 13.3163 26.9594 13.1035C26.429 12.8975 25.8231 12.7562 24.9366 12.7165C24.0481 12.6761 23.764 12.666 21.501 12.666C19.2379 12.666 18.9536 12.6754 18.0646 12.7165Z"
                fill="var(--color-blue-600)"
              />
            </svg>
          ),
          link: instagramLink,
        },
        {
          icon: (
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19.8848 19.1921V18.5465C19.6647 18.511 19.4424 18.4915 19.2197 18.4883C17.0628 18.4836 15.1533 19.9071 14.5055 22.0024C13.8578 24.0977 14.6224 26.3786 16.3928 27.6332C15.7436 26.9256 15.3093 26.0417 15.1425 25.0882C14.9756 24.1348 15.0833 23.1526 15.4525 22.2601C15.8217 21.3676 16.4367 20.603 17.2231 20.0586C18.0096 19.5143 18.934 19.2133 19.8846 19.1922L19.8848 19.1921Z"
                fill="var(--color-blue-600)"
              />
              <path
                d="M20.0044 26.5051C21.2103 26.5034 22.2016 25.5359 22.2544 24.3089V13.3593H24.2184C24.1784 13.1305 24.1592 12.8984 24.1613 12.666L21.4749 12.666V23.605C21.4302 24.8382 20.4366 25.8151 19.2249 25.8171C18.8628 25.814 18.5066 25.7233 18.1857 25.5525C18.3937 25.846 18.6669 26.0853 18.9829 26.2508C19.299 26.4164 19.649 26.5035 20.0044 26.5051ZM27.887 17.0744V16.4658C27.1641 16.4661 26.4573 16.2488 25.8553 15.8413C26.383 16.4662 27.0962 16.899 27.887 17.0744Z"
                fill="var(--color-blue-600)"
              />
              <path
                d="M24.1611 23.5198V17.9577C25.2485 18.7522 26.5537 19.1975 27.892 19.1944V17.0581C27.1014 16.888 26.3865 16.4608 25.8551 15.8409C25.4307 15.5613 25.0666 15.1965 24.7852 14.7689C24.5038 14.3412 24.3109 13.8596 24.2182 13.3535H22.2542V24.3085C22.2351 24.7854 22.0686 25.2317 21.7816 25.6089C21.4946 25.9862 21.127 26.2596 20.6784 26.3975C20.2298 26.5354 19.7634 26.5386 19.3193 26.3861C18.8753 26.2336 18.4678 25.9445 18.1928 25.558C17.7477 25.3194 17.38 24.9269 17.1783 24.471C16.9717 24.0039 16.9154 23.4825 17.0349 22.9849C17.1543 22.4872 17.4337 22.0445 17.8286 21.7272C18.2235 21.4099 18.7113 21.2361 19.2143 21.2336C19.4399 21.2356 19.664 21.2713 19.8794 21.3395L19.8881 19.1886C18.9324 19.2051 17.9952 19.4849 17.2036 20.0307C16.412 20.5764 15.7914 21.3985 15.4212 22.2961C15.051 23.1937 14.9453 24.1817 15.1169 25.1394C15.2885 26.0972 15.73 26.9834 16.3875 27.6901C17.2228 28.2646 18.2119 28.5622 19.2195 28.5421C21.9446 28.5421 24.1554 26.2952 24.1611 23.5198Z"
                fill="var(--color-blue-600)"
              />
            </svg>
          ),
          link: tiktokLink,
        },
        {
          icon: (
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_17543_35429)">
                <path
                  d="M28.1705 15.0021C30.3363 18.1473 31.4059 21.6951 31.006 25.7793C31.0044 25.7966 30.9953 25.8124 30.9809 25.8229C29.3408 27.0124 27.7517 27.7343 26.185 28.213C26.1728 28.2167 26.1597 28.2165 26.1477 28.2125C26.1356 28.2084 26.1251 28.2008 26.1176 28.1905C25.7557 27.6931 25.4268 27.1686 25.1386 26.6179C25.1221 26.5855 25.1372 26.5464 25.1713 26.5336C25.6936 26.3393 26.1903 26.1063 26.668 25.8304C26.7056 25.8087 26.708 25.7554 26.6733 25.7298C26.5719 25.6555 26.4714 25.5773 26.3753 25.4992C26.3573 25.4848 26.3331 25.4819 26.3128 25.4916C23.2111 26.9063 19.8135 26.9063 16.6752 25.4916C16.6548 25.4826 16.6306 25.4857 16.6131 25.4999C16.5172 25.578 16.4165 25.6555 16.3161 25.7298C16.2814 25.7554 16.2842 25.8087 16.3221 25.8304C16.7998 26.1011 17.2965 26.3393 17.8181 26.5346C17.8519 26.5474 17.868 26.5855 17.8512 26.6179C17.5693 27.1694 17.2404 27.6938 16.8718 28.1912C16.8557 28.2114 16.8293 28.2206 16.8044 28.213C15.2451 27.7343 13.656 27.0124 12.0159 25.8229C12.0023 25.8124 11.9925 25.7959 11.991 25.7786C11.6569 22.2458 12.3379 18.6687 14.8239 15.0014C14.8299 14.9917 14.839 14.9841 14.8496 14.9796C16.0728 14.4251 17.3833 14.0172 18.753 13.7842C18.7779 13.7804 18.8029 13.7918 18.8158 13.8136C18.985 14.1095 19.1785 14.4891 19.3094 14.7992C20.7531 14.5814 22.2195 14.5814 23.6934 14.7992C23.8243 14.4957 24.0111 14.1095 24.1796 13.8136C24.1856 13.8028 24.1949 13.7941 24.2062 13.7888C24.2174 13.7836 24.2301 13.7819 24.2424 13.7842C25.6128 14.0179 26.9233 14.4258 28.1456 14.9796C28.1564 14.9841 28.1652 14.9917 28.1705 15.0021ZM20.0434 21.7192C20.0585 20.6748 19.2876 19.8106 18.3198 19.8106C17.36 19.8106 16.5966 20.6673 16.5966 21.7192C16.5966 22.7709 17.3752 23.6276 18.3198 23.6276C19.2799 23.6276 20.0434 22.7709 20.0434 21.7192ZM26.4153 21.7192C26.4304 20.6748 25.6595 19.8106 24.6921 19.8106C23.732 19.8106 22.9686 20.6673 22.9686 21.7192C22.9686 22.7709 23.7471 23.6276 24.6921 23.6276C25.6595 23.6276 26.4153 22.7709 26.4153 21.7192Z"
                  fill="var(--color-blue-600)"
                />
              </g>
              <defs>
                <clipPath id="clip0_17543_35429">
                  <rect
                    width="42"
                    height="42"
                    fill="white"
                    transform="translate(11.5 11)"
                  />
                </clipPath>
              </defs>
            </svg>
          ),
          link: discordLink,
        },
        {
          icon: (
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.9027 27.0868L18.1736 27.0206C16.9662 26.9975 15.7558 27.0436 14.5721 26.8046C12.7714 26.4475 12.6438 24.6967 12.5104 23.2281C12.3264 21.1635 12.3976 19.0614 12.7447 17.014C12.9407 15.8651 13.7118 15.1796 14.9044 15.105C18.9301 14.8343 22.9826 14.8664 26.9994 14.9927C27.4236 15.0043 27.8507 15.0676 28.269 15.1396C30.3339 15.4909 30.3842 17.475 30.5181 19.1452C30.6516 20.8326 30.5952 22.5287 30.3401 24.2046C30.1354 25.5922 29.7437 26.7559 28.091 26.8682C26.0202 27.0151 23.997 27.1334 21.9204 27.0957C21.9205 27.0868 21.9086 27.0868 21.9027 27.0868ZM19.7103 23.5737C21.2708 22.704 22.8016 21.8488 24.3531 20.985C22.7897 20.1153 21.2619 19.2601 19.7103 18.3962V23.5737Z"
                fill="var(--color-blue-600)"
              />
            </svg>
          ),
          link: youtubeLink,
        },
        {
          icon: (
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.5001 12.3965C16.7488 12.3965 12.8965 16.2483 12.8965 20.9998C12.8965 24.5226 15.0149 27.5489 18.0463 28.8796C18.0221 28.2788 18.042 27.5577 18.1961 26.904C18.3614 26.2056 19.3031 22.2161 19.3031 22.2161C19.3031 22.2161 19.0282 21.6669 19.0282 20.8549C19.0282 19.58 19.7672 18.6278 20.6874 18.6278C21.47 18.6278 21.8481 19.2156 21.8481 19.9194C21.8481 20.7061 21.3463 21.8828 21.0883 22.9726C20.8727 23.8852 21.5459 24.6296 22.4462 24.6296C24.0763 24.6296 25.1742 22.536 25.1742 20.0555C25.1742 18.1699 23.9041 16.7586 21.5942 16.7586C18.9845 16.7586 17.3586 18.7048 17.3586 20.8787C17.3586 21.6282 17.5796 22.1568 17.9258 22.5661C18.0849 22.7541 18.1071 22.8297 18.0494 23.0456C18.0082 23.2039 17.9134 23.585 17.8742 23.736C17.8168 23.9539 17.6403 24.0318 17.4434 23.9513C16.2414 23.4606 15.6815 22.1443 15.6815 20.6645C15.6815 18.2207 17.7427 15.2902 21.8303 15.2902C25.1151 15.2902 27.277 17.6671 27.277 20.2185C27.277 23.5934 25.4007 26.1148 22.6349 26.1148C21.706 26.1148 20.8322 25.6127 20.533 25.0424C20.533 25.0424 20.0335 27.0246 19.9277 27.4074C19.7453 28.0707 19.3883 28.7336 19.0618 29.2504C19.8356 29.4788 20.6529 29.6032 21.5001 29.6032C26.2511 29.6032 30.1032 25.7513 30.1032 20.9998C30.1032 16.2483 26.2511 12.3965 21.5001 12.3965Z"
                fill="var(--color-blue-600)"
              />
            </svg>
          ),
          link: pinterestLink,
        },
        {
          icon: (
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.9984 13.1426C15.1451 13.1426 13.6428 14.6449 13.6428 16.4981V26.0728C13.6428 27.926 15.1451 29.4283 16.9984 29.4283H20.2111V23.4516H18.7532V21.2011H20.1674C20.1674 20.9746 20.1681 20.7566 20.1687 20.5433C20.17 20.13 20.1713 19.7341 20.1674 19.3269C20.1674 17.5549 21.5271 17.0407 22.7495 17.0407H24.8095H24.8105V19.2638C24.6925 19.2645 24.3417 19.2642 24.0205 19.264C23.8705 19.2639 23.7269 19.2638 23.6165 19.2638C23.615 19.2638 23.6127 19.2637 23.6096 19.2636C23.5231 19.2619 22.8441 19.2479 22.8441 19.9239C22.8485 20.2099 22.8441 21.1948 22.8441 21.1948H24.8185L24.6585 23.4088H22.8902V29.4283H26.573C28.4262 29.4283 29.9285 27.926 29.9285 26.0728V16.4981C29.9285 14.6449 28.4262 13.1426 26.573 13.1426H16.9984Z"
                fill="var(--color-blue-600)"
              />
            </svg>
          ),
          link: facebookLink,
        },
        {
          icon: (
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.4331 28.6817C22.9463 28.6817 24.0786 27.5674 24.0786 27.5674C24.178 27.4842 24.2912 27.4046 24.2912 27.4046C25.1971 26.8096 26.6657 27.2385 26.6657 27.2385C27.1993 27.3649 27.2147 26.9618 27.2147 26.9618L27.2559 26.505C27.2949 26.0571 27.9832 26.0619 27.9832 26.0619C28.8897 26.0264 29.2713 25.6552 29.4285 25.3933C29.5973 25.1422 29.2784 25.0712 29.2784 25.0712C27.091 24.4605 26.0297 22.3843 26.0297 22.3843C25.5355 21.5169 26.2127 21.1661 26.2127 21.1661C26.3958 21.0369 27.2924 20.7416 27.2924 20.7416C28.0323 20.4449 27.7865 19.9296 27.7865 19.9296C27.512 19.3757 26.8715 19.745 26.8715 19.745C26.5687 19.9057 26.3408 19.8925 26.3408 19.8925C25.835 19.9022 25.7742 19.7938 25.7742 19.7938L25.7915 17.3917C25.7915 15.1949 23.8539 13.4141 21.4638 13.4141H21.4223C19.0321 13.4141 17.0946 15.1949 17.0946 17.3917L17.112 19.7938C17.112 19.7938 17.0512 19.9022 16.5453 19.8925C16.5453 19.8925 16.3174 19.9057 16.0146 19.745C16.0146 19.745 15.3742 19.3758 15.0997 19.9296C15.0997 19.9296 14.8536 20.4449 15.5938 20.7416C15.5938 20.7416 16.4905 21.0369 16.6734 21.1661C16.6734 21.1661 17.3506 21.5168 16.8565 22.3843C16.8565 22.3843 15.7954 24.4605 13.6078 25.0712C13.6078 25.0712 13.2889 25.1421 13.4578 25.3933C13.615 25.6552 13.9968 26.0264 14.9029 26.0619C14.9029 26.0619 15.5914 26.0571 15.6304 26.505L15.6716 26.9618C15.6716 26.9618 15.687 27.3649 16.2206 27.2385C16.2206 27.2385 17.6891 26.8096 18.595 27.4046C18.595 27.4046 18.7082 27.4842 18.8078 27.5674C18.8078 27.5674 19.9401 28.6817 21.4533 28.6817H21.4331Z"
                fill="var(--color-blue-600)"
              />
            </svg>
          ),
          link: snapchatLink,
        },
      ].map(({ icon, link }) => (
        <SocialImage
          key={link}
          href={link}
          target="_blank"
          rel="noopener noreferrer">
          {icon}
        </SocialImage>
      ))}
    </SocialsContainer>
  )
}

export default Socials
